import React from 'react';
import { Spin } from 'antd';

const SpinnerLoading = ({ message = 'Caricamento...' }) => {
  return <div className="spinnerLoading">
    <Spin tip={message} />
  </div>
}

export default SpinnerLoading;